import { buttonSaveUpdate, formEditReportedAnswer } from "_constants";
import { Button } from "primereact/button";

export const ModalResolveReportPartiallyWrongFooter = () => {
  return (
    <div className="flex-container justify-end padd-24">
      <Button label={buttonSaveUpdate} form={formEditReportedAnswer} />
    </div>
  );
};
